module.exports = __webpack_public_path__ + "d145d0538a04a75092dce12a5c7683e3.svg";